import React, { useEffect } from "react";
import NavbarRecords from "../../Components/SoulflowRecordsNew/NavbarRecords";
import HeroRecords from "../../Components/SoulflowRecordsNew/HeroRecords";
import AlbumsSection from "../../Components/SoulflowRecordsNew/AlbumsSection";
import MadeForYou from "../../Components/SoulflowRecordsNew/MadeForYou";
import TopChose from "../../Components/SoulflowRecordsNew/TopChose";
import MiniAudioPlayer from "../../Components/SoulflowRecordsNew/MiniAudioPlayer";
import BlueNotificationBanner from "../../Components/SoulflowRecordsNew/BlueNotificationBanner";
import FooterRecords from "../../Components/SoulflowRecordsNew/FooterRecords";
import { scrollToTop } from "../../helper/helper";
import FooterNew from "../../Components/LandingNew/FooterNew";

export default function SoulflowRecordsNew() {
  useEffect(() => {
    scrollToTop();
  }, []);

  return (
    <div className="min-h-screen bg-black text-white  flex flex-col justify-between">
      <div>
        {/* Navbar */}
        <NavbarRecords />

        {/* Hero Section */}
        <HeroRecords />

        {/* Albums Grid */}
        <AlbumsSection />

        {/* Made For You */}
        <MadeForYou />

        {/* Your Top Chose */}
        <TopChose />

        {/* Blue Notice Banner */}
        {/* <BlueNotificationBanner /> */}
      </div>

      {/* Footer & Audio Player */}
      <div>
        <MiniAudioPlayer />
        <FooterNew fbLink={"https://www.facebook.com/babsoulflowrecordsbyajb"}
          instaLink={"https://www.instagram.com/bab_soul_flow_records_by_ajb/"} />
      </div>
    </div>
  );
}
